<script setup lang="ts">
import type { CartAnimal } from '@ShoppingCartModule';
import { convertToTitleCase } from '@Helpers';

defineProps<{
  animal: CartAnimal;
  animalProfileId?: string | null;
}>();
</script>

<template>
  <div class="flex items-start gap-3">
    <RouterLink
      v-if="animalProfileId"
      class="shrink-0"
      :to="`/shelter/animal-profile/${animalProfileId}`"
    >
      <AAvatar
        size="lg"
        type="Animal"
        :src="animal.photo"
      />
    </RouterLink>

    <AAvatar
      v-else
      size="lg"
      type="Animal"
      :src="animal.photo"
    />

    <div class="flex min-w-0 flex-col">
      <RouterLink
        v-if="animalProfileId"
        class="min-w-0"
        :to="`/shelter/animal-profile/${animalProfileId}`"
      >
        <span class="af-link font-medium">{{ animal.animal_name }}</span>
      </RouterLink>

      <span
        v-else
        class="font-medium"
      >
        {{ animal.animal_name }}
      </span>

      <span class="text-sm text-gray-500">{{ animal.species ? convertToTitleCase(animal.species) : '—' }}</span>
    </div>
  </div>
</template>
